let d_shape_not_round = true
let is_earrings = false
let not_round_cut_scale = ['Poor','Fair','Good','VG','EX']
let round_cut_scale = ['Poor','Good','VG','EX','Ideal']

let filter_values_default = {
  'CTS_MIN':50,
  'CTS_MAX':1000,
  'COLOR_MIN':663,
  'COLOR_MAX':994.5,
  'CLARITY_MIN':3,
  'CLARITY_MAX':6,
  'CUT_MIN':3,
  'CUT_MAX':4,
  'FLUORESCENT_MIN':2,
  'FLUORESCENT_MAX':4,
  'PRICE_PHP_MIN':0,
  'PRICE_PHP_MAX':5_000_000,
}


if(url.searchParams.get('earrings') == 'true'){
  is_earrings = true
}

if(url.searchParams.get('shape').slice(0,-4).toUpperCase() == 'ROUND' && diamond_type == '0'){
  d_shape_not_round = false
}
else if(url.searchParams.get('shape').slice(0,-4).toUpperCase() == 'ALL'){
  d_shape_not_round = false
  document.getElementById('Customize-Shape-Filter-Section').style.display = 'block'
  document.getElementById('Customize-Source-Filter-Section').style.display = 'block'
  filter_values_default['PRICE_PHP_MAX'] = 25_000_000
  setPriceFilterMaxLabel(25_000_000)
  document.getElementById('Filter-Price-Max').style.width = '72px'
}
else {
  //update Cut Filter for Non Round Shapes
  let cut_info_text = document.getElementById('Filter-Info-Cut-Text')
  cut_info_text.innerText = 'The cut of a diamond is often considered the most crucial factor affecting its beauty. It determines how effectively the stone interacts with light, creating brilliance and sparkle. Lucce only uses fancy shape diamonds with Excellent (EX) cut.'
  let cut_lbl = document.getElementById('Cut-EX')
  cut_lbl.style.paddingLeft = '0px'
  cut_lbl.style.marginLeft = '-10px'

  Array.from(document.getElementById('Slider-Cut-Values').querySelectorAll('span')).forEach((span,index)=>{
    span.innerText = not_round_cut_scale[index]
  })
}



//if natural 
if(diamond_type == '1'){
  filter_values_default['COLOR_MIN'] = 442
  filter_values_default['CLARITY_MIN'] = 2
  filter_values_default['CUT_MIN'] = 3
  filter_values_default['PRICE_PHP_MAX'] = 25_000_000
  document.getElementById('Filter-Price-Max').style.width = '72px'
  setPriceFilterMaxLabel(25_000_000)
}


//update filter default values
if(d_shape_not_round && diamond_type == '1'){
  filter_values_default['CUT_MIN'] = 3
} else if(d_shape_not_round) {
  filter_values_default['CUT_MIN'] = 4
}

if(is_earrings || is_necklace){
  filter_values_default['CTS_MIN'] = 25
  document.getElementById('Customize-Filter-Label-CTS-MIN').innerText = "0.25"
}


let clarity_index = {
  0:'SI2',
  1:'SI1',
  2:'VS2',
  3:'VS1',
  4:'VVS2',
  5:'VVS1',
  6:'IF',
  7:'FL'
}

let cut_index = {
  0:'P',
  1:'G',
  2:'VG',
  3:'EX',
  4:'ID',
}

let fluorescent_index = {
  2:'SL',
  3:'F',
  4:'N',
}

if(diamond_type == '1'){
  cut_index = {
    3:'VG',
    4:'EX',
  }
}

let color_index = {
  442:'I',
  552.5:'H',
  663:'G',
  773.5:'F',
  884:'E',
  994.5:'D'
}

let color_index_numb = {
  442:2,
  552.5:3,
  663:4,
  773.5:5,
  884:6,
  994.5:7
}

updateSlider('Clarity',3,6)
updateSlider('Color',4,7)
if(d_shape_not_round){
  updateSlider('Cut',4,4)
} else{
  updateSlider('Cut',3,4)
}
updateSlider('Fluorescent',2,4)

function updateSlider(name,min,max){
    let array = Array.from(document.getElementById('Slider-'+ name +'-Values').querySelectorAll('span'))

    array.forEach(span=>span.style.color='#cecfd0')

    for(let i = Number(min); i < Number(max + 1);i++){
        array[i].style.color = 'black'
    }
}



  //Filter toggle - Small Desktops/Tablets/Mobile

  let filter_open = document.getElementById('Customize-Filter-Open')
  let filter_close = document.getElementById('Customize-Filter-Exit')
  let filter_container = document.getElementById('Customize-Filter-Container')
  let see_results = document.getElementById('Filter-Customize-Loader-Results')
  
  filter_open.addEventListener('click',()=>{
    filter_container.style.display = 'block'
  })
  
  filter_close.addEventListener('click',()=>{
    filter_container.style.display = 'none'
  })

  see_results.addEventListener('click',()=>{
    filter_container.style.display = 'none'
  })


  //Filter info
  let carat_info_open = document.getElementById('Filter-Info-Carat')
  let carat_info_exit = document.getElementById('Filter-Info-Carat-Exit')
   let carat_info_container = document.getElementById('Filter-Info-Carat-Container')
   let carat_main_container = document.getElementById('Filter-Main-Container-Carat')
   let clarity_info_open = document.getElementById('Filter-Info-Clarity')
   let clarity_info_exit = document.getElementById('Filter-Info-Clarity-Exit')
    let clarity_info_container = document.getElementById('Filter-Info-Clarity-Container')
    let clarity_main_container = document.getElementById('Filter-Main-Container-Clarity')
    let color_info_open = document.getElementById('Filter-Info-Color')
  let color_info_exit = document.getElementById('Filter-Info-Color-Exit')
   let color_info_container = document.getElementById('Filter-Info-Color-Container')
   let color_main_container = document.getElementById('Filter-Main-Container-Color')
   let cut_info_open = document.getElementById('Filter-Info-Cut')
   let cut_info_exit = document.getElementById('Filter-Info-Cut-Exit')
    let cut_info_container = document.getElementById('Filter-Info-Cut-Container')
    let cut_main_container = document.getElementById('Filter-Main-Container-Cut')
    let fluorescent_info_open = document.getElementById('Filter-Info-Fluorescent')
   let fluorescent_info_exit = document.getElementById('Filter-Info-Fluorescent-Exit')
    let fluorescent_info_container = document.getElementById('Filter-Info-Fluorescent-Container')
    let fluorescent_main_container = document.getElementById('Filter-Main-Container-Fluorescent')

  carat_info_open.addEventListener('click',()=>{
    closeAllInfo()
      if(window.innerWidth > 1295  || window.innerWidth < 500)
      carat_main_container.style.visibility = 'hidden'
      carat_info_container.style.display = 'block'
  })
  carat_info_exit.addEventListener('click',()=>{
    if(window.innerWidth > 1295  || window.innerWidth < 500)
    carat_main_container.style.visibility = 'visible'
    carat_info_container.style.display = 'none'
  })
  clarity_info_open.addEventListener('click',()=>{
    closeAllInfo()
    if(window.innerWidth > 1295  || window.innerWidth < 500){
      clarity_main_container.style.visibility = 'hidden'
      // color_main_container.style.visibility = 'hidden'
    }
    clarity_info_container.style.display = 'block'
})
clarity_info_exit.addEventListener('click',()=>{
  if(window.innerWidth > 1295  || window.innerWidth < 500){
    clarity_main_container.style.visibility = 'visible'
    // color_main_container.style.visibility = 'visible'
  }
    
  clarity_info_container.style.display = 'none'
})
color_info_open.addEventListener('click',()=>{
  closeAllInfo()
  if(window.innerWidth > 1295  || window.innerWidth < 500)
    color_main_container.style.visibility = 'hidden'
  color_info_container.style.display = 'block'
})
color_info_exit.addEventListener('click',()=>{
  if(window.innerWidth > 1295  || window.innerWidth < 500)
    color_main_container.style.visibility = 'visible'
  color_info_container.style.display = 'none'
})

cut_info_open.addEventListener('click',()=>{
  closeAllInfo()
  if(window.innerWidth > 1295  || window.innerWidth < 500)
    cut_main_container.style.visibility = 'hidden'
  cut_info_container.style.display = 'block'
})
cut_info_exit.addEventListener('click',()=>{
  if(window.innerWidth > 1295  || window.innerWidth < 500)
    cut_main_container.style.visibility = 'visible'
  cut_info_container.style.display = 'none'
})

fluorescent_info_open.addEventListener('click',()=>{
  closeAllInfo()
  if(window.innerWidth > 1295  || window.innerWidth < 500)
    fluorescent_main_container.style.visibility = 'hidden'
  fluorescent_info_container.style.display = 'block'
})
fluorescent_info_exit.addEventListener('click',()=>{
  if(window.innerWidth > 1295  || window.innerWidth < 500)
    fluorescent_main_container.style.visibility = 'visible'
  fluorescent_info_container.style.display = 'none'
})

function closeAllInfo(){
  carat_main_container.style.visibility = 'visible'
  clarity_main_container.style.visibility = 'visible'
  color_main_container.style.visibility = 'visible'

  carat_info_container.style.display= 'none'
  clarity_info_container.style.display= 'none'
  color_info_container.style.display= 'none'
}

let filter_reset_btn = document.getElementById('Customize-Filter-Reset')

//reset filter
filter_reset_btn.addEventListener('click',resetFilter)


function resetFilter(){
  $( "#Slider-Range-Carat" ).slider( "option", "values", [ filter_values_default['CTS_MIN'], filter_values_default['CTS_MAX'] ]);
  $( "#Slider-Range-Color" ).slider( "option", "values", [ filter_values_default['COLOR_MIN'], filter_values_default['COLOR_MAX'] ]);
  $( "#Slider-Range-Clarity" ).slider( "option", "values", [ filter_values_default['CLARITY_MIN'], filter_values_default['CLARITY_MAX'] ]);
  $( "#Slider-Range-Cut" ).slider( "option", "values", [ filter_values_default['CUT_MIN'], filter_values_default['CUT_MAX'] ]);
  $( "#Slider-Range-Fluorescent" ).slider( "option", "values", [ filter_values_default['FLUORESCENT_MIN'], filter_values_default['FLUORESCENT_MAX'] ]);
  $( "#Slider-Range-Price" ).slider( "option", "values", [ filter_values_default['PRICE_PHP_MIN'], filter_values_default['PRICE_PHP_MAX'] ]);

  //reset carat inputs
  $( "#Filter-Carat-Min" ).val( filter_values_default['CTS_MIN']/100);
  $( "#Filter-Carat-Max" ).val( filter_values_default['CTS_MAX']/100);

  //reset price inputs
    setPriceFilterInput(document.getElementById('Filter-Price-Min'), filter_values_default['PRICE_PHP_MIN']);
    setPriceFilterInput(document.getElementById('Filter-Price-Max'), filter_values_default['PRICE_PHP_MAX']);
    updatePriceFilterCurrencyLabels();


  if(window.innerWidth > 1295){
    filter_igi_btn.click()
  } else {
    filter_igi_btn_small.click()
  }

  if(diamond_type == '0'){
    //LAB DIAMOND
    updateSlider('Color',4,7)
    updateSlider('Clarity',3,6)
    if(d_shape_not_round){
      updateSlider('Cut',4,4)
    } else {
      updateSlider('Cut',3,4)
    }
  } else {
    //NATURAL DIAMOND
    updateSlider('Color',2,7)
    updateSlider('Clarity',2,6)
    updateSlider('Cut',3,4)
    updateSlider('Fluorescent',2,4)
    document.getElementById('Filter-Certificate-Btn-GIA-Small-Screen').classList.add('filter-certificate-btn-active')
    document.getElementById('Filter-Certificate-Btn-GIA').classList.add('filter-certificate-btn-active')

  }
  

  let custom_event = new Event('change')
  let filter_container = document.getElementById('Customize-Filter-Container')
  filter_container.dispatchEvent(custom_event)
}

let filter_igi_btn = document.getElementById('Filter-Certificate-Btn-IGI')
let filter_gia_btn = document.getElementById('Filter-Certificate-Btn-GIA')
let filter_igi_btn_small = document.getElementById('Filter-Certificate-Btn-IGI-Small-Screen')
let filter_gia_btn_small = document.getElementById('Filter-Certificate-Btn-GIA-Small-Screen')

filter_igi_btn.addEventListener('click',()=>{filterCertificateListner(filter_igi_btn,'IGI')})
filter_igi_btn_small.addEventListener('click',()=>{filterCertificateListner(filter_igi_btn_small,'IGI')})
filter_gia_btn.addEventListener('click',()=>{filterCertificateListner(filter_gia_btn,'GIA')})
filter_gia_btn_small.addEventListener('click',()=>{filterCertificateListner(filter_gia_btn_small,'GIA')})


function filterCertificateListner(elem,name){
 

  if(diamond_type == '0'){
    filter_gia_btn.classList.remove('filter-certificate-btn-active')
    filter_gia_btn_small.classList.remove('filter-certificate-btn-active')
    filter_igi_btn.classList.remove('filter-certificate-btn-active')
    filter_igi_btn_small.classList.remove('filter-certificate-btn-active')
    elem.classList.add('filter-certificate-btn-active')
    //LAB DIAMOND
    if((name == 'GIA' && d_shape_not_round == true) || d_shape_not_round == true & name == 'IGI'){
      $( "#Slider-Range-Cut" ).slider( "option", "values", [ 4, 4] )
      updateSlider('Cut',4,4)
    } else if(name == 'GIA' && d_shape_not_round == false){
      $( "#Slider-Range-Cut" ).slider( "option", "values", [ 3, 3] )
      updateSlider('Cut',3,3)
    }
    else {
      $( "#Slider-Range-Cut" ).slider( "option", "values", [ 3, 4] )
      updateSlider('Cut',3,4)
    }
    
    let custom_event = new Event('change')
    let filter_container = document.getElementById('Customize-Filter-Container')
    filter_container.dispatchEvent(custom_event)

  }
 


}

//Source Type
let filter_lab_btn = document.getElementById('Filter-Source-Btn-Lab')
let filter_natural_btn = document.getElementById('Filter-Source-Btn-Natural')
// let filter_igi_btn_small = document.getElementById('Filter-Certificate-Btn-IGI-Small-Screen')
// let filter_gia_btn_small = document.getElementById('Filter-Certificate-Btn-GIA-Small-Screen')

filter_lab_btn.addEventListener('click',()=>{filterSourceListner(filter_lab_btn,'lab')})
// filter_igi_btn_small.addEventListener('click',()=>{filterCertificateListner(filter_igi_btn_small,'IGI')})
filter_natural_btn.addEventListener('click',()=>{filterSourceListner(filter_natural_btn,'natural')})
// filter_gia_btn_small.addEventListener('click',()=>{filterCertificateListner(filter_gia_btn_small,'GIA')})


function filterSourceListner(elem,name){
  
      document.getElementById('Color-I').style.marginLeft = ''
      document.getElementById('Color-G').style.marginLeft = ''
  
  filter_lab_btn.classList.remove('filter-source-btn-active')
  // filter_gia_btn_small.classList.remove('filter-source-btn-active')
  filter_natural_btn.classList.remove('filter-source-btn-active')
  //filter_igi_btn_small.classList.remove('filter-source-btn-active')
  elem.classList.add('filter-source-btn-active')

  if(name == 'lab'){
  
    filter_igi_btn.classList.add('filter-certificate-btn-active')
    filter_igi_btn_small.classList.add('filter-certificate-btn-active')
    filter_gia_btn.classList.remove('filter-certificate-btn-active')
    filter_gia_btn_small.classList.remove('filter-certificate-btn-active')
    //add Certificate Selection //GIA only
    document.getElementById('Filter-Certificate-Btn-IGI-Small-Screen').style.visibility = 'visible'

    cut_index = {
      0:'P',
      1:'G',
      2:'VG',
      3:'EX',
      4:'ID',
    }
    filter_values_default['COLOR_MIN'] = 663
    filter_values_default['CLARITY_MIN'] = 3
    filter_values_default['CUT_MIN'] = 3
    update_lab_diamond_filter()
    Array.from(document.getElementById('Slider-Cut-Values').querySelectorAll('span')).forEach((span,index)=>{
      if(d_shape_not_round){
        span.innerText = not_round_cut_scale[index]
      } else {
        span.innerText = round_cut_scale[index]
      }
    })
    diamond_type = '0'
    document.getElementById('Customize-Banner2-Title-Diamond-Type').innerText = 'Lab'
    root.style.setProperty('--columnHeaderColor', '#bdcec0');
    root.style.setProperty('--columnRowHighlight', '#ebf3ec');
    root.style.setProperty('--columnRowHover', '#bdcec0');
    root.style.setProperty('--filterCertActiveColor', '#2C4D3C');
    root.style.setProperty('--filterCertActiveFontColor', '#fff');

    document.getElementById('Filter-Certificate-Btn-IGI').style.opacity = '1'
    document.getElementById('Filter-Certificate-Btn-IGI').classList.remove('customize-no-hover')
    document.getElementById('Filter-Certificate-Btn-GIA').classList.remove('filter-certificate-btn-active')

   slider_clarity_stop($( "#Slider-Range-Clarity" ).slider('option','values'))
   slider_color_stop($( "#Slider-Range-Color" ).slider('option','values'))


  } else {
    //Natural

    

    if(window.innerWidth > 750){
        document.getElementById('Color-I').style.marginLeft = '-7px'
        document.getElementById('Color-G').style.marginLeft = '3px'
    }
    cut_index = {
      3:'VG',
      4:'EX',
    }
    filter_values_default['COLOR_MIN'] = 442
    filter_values_default['CLARITY_MIN'] = 2
    filter_values_default['CUT_MIN'] = 3
    update_natural_diamond_filter()
    Array.from(document.getElementById('Slider-Cut-Values').querySelectorAll('span')).forEach((span,index)=>{
      span.innerText = not_round_cut_scale[index]
    })
    diamond_type = '1'
    document.getElementById('Customize-Banner2-Title-Diamond-Type').innerText = 'Natural'
    root.style.setProperty('--columnHeaderColor', '#ccb763');
    root.style.setProperty('--columnRowHighlight', '#FFF9EB');
    root.style.setProperty('--columnRowHover', '#ccb763');
    root.style.setProperty('--filterCertActiveColor', '#ccb763');
    root.style.setProperty('--filterCertActiveFontColor', '#000');


    document.getElementById('Filter-Certificate-Btn-IGI').style.opacity = '.3'
    document.getElementById('Filter-Certificate-Btn-IGI').classList.add('customize-no-hover')
    document.getElementById('Filter-Certificate-Btn-GIA').classList.add('filter-certificate-btn-active')
    
    //remove Certificate Selection //GIA only
    document.getElementById('Filter-Certificate-Btn-IGI-Small-Screen').style.visibility = 'hidden'

    filter_igi_btn.classList.remove('filter-certificate-btn-active')
    filter_igi_btn_small.classList.remove('filter-certificate-btn-active')
    filter_gia_btn.classList.add('filter-certificate-btn-active')
    filter_gia_btn_small.classList.add('filter-certificate-btn-active')
  }

  let custom_event = new Event('change')
  let filter_container = document.getElementById('Customize-Filter-Container')
  filter_container.dispatchEvent(custom_event)
}

//Carat/Price input

let carat_min = document.getElementById('Filter-Carat-Min')
let carat_max = document.getElementById('Filter-Carat-Max')

carat_min.addEventListener('input',(e)=>{
  if(e.target.value < 0){
    e.target.value = 0
  }
})

carat_min.addEventListener('change',(e)=>{
  let min_val = Number(carat_min.value)
  let max_val = Number(carat_max.value)

  if(min_val > max_val){
    min_val = carat_max.value
    carat_min.value = carat_max.value
  }

  $( "#Slider-Range-Carat" ).slider( "option", "values", [min_val * 100, max_val * 100 ] )
})

carat_max.addEventListener('change',(e)=>{
  let min_val = Number(carat_min.value)
  let max_val = Number(carat_max.value)

  if(max_val < min_val){
    max_val = carat_min.value
    carat_max.value = carat_min.value
  }

  $( "#Slider-Range-Carat" ).slider( "option", "values", [min_val * 100, max_val * 100 ] )
})


let price_min = document.getElementById('Filter-Price-Min')
let price_max = document.getElementById('Filter-Price-Max')

function formatSelectedCurrencyNumberFromPhp(phpValue) {
  if (window.LucceCurrencyFormatter && typeof window.LucceCurrencyFormatter.phpToSelectedAmount === 'function') {
    var currencyState = window.LucceCurrencyFormatter.getState();
    var fractionDigits = currencyState ? 2 : 0;
    return window.LucceCurrencyFormatter.phpToSelectedAmount(Number(phpValue)).toLocaleString(undefined, {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    });
  }

  return Number(phpValue).toLocaleString();
}

function getPhpValueFromSelectedCurrencyInput(inputElement) {
  var selectedValue = parseFloat((inputElement.value || '').replace(/,/g, '').replace(/[^\d.]/g, '')) || 0;

  if (window.LucceCurrencyFormatter && typeof window.LucceCurrencyFormatter.selectedToPhpAmount === 'function') {
    return Math.round(window.LucceCurrencyFormatter.selectedToPhpAmount(selectedValue));
  }

  return Math.round(selectedValue);
}

function setPriceFilterInput(inputElement, phpValue) {
  inputElement.value = formatSelectedCurrencyNumberFromPhp(phpValue);
  inputElement.setAttribute('data-php-value', Math.round(Number(phpValue)));
}

function setPriceFilterMaxLabel(phpValue) {
  var label = document.getElementById('Customize-Filter-Label-PRICE-MAX');
  if (!label) return;

  label.setAttribute('data-lucce-price-filter-display', Math.round(Number(phpValue)));

  if (window.LucceCurrencyFormatter && typeof window.LucceCurrencyFormatter.formatPhpPrice === 'function') {
    label.textContent = window.LucceCurrencyFormatter.formatPhpPrice(phpValue);
    return;
  }

  label.textContent = '₱' + Number(phpValue).toLocaleString();
}

function updatePriceFilterCurrencyLabels() {
  var formatter = window.LucceCurrencyFormatter;
  var state = formatter && typeof formatter.getState === 'function' ? formatter.getState() : null;

  if (!state) return;

  document.querySelectorAll('.slider-price-currency').forEach(function(label) {
    label.textContent = state.code || state.prefix || 'PHP';
  });

  var maxLabel = document.getElementById('Customize-Filter-Label-PRICE-MAX');
  if (maxLabel && maxLabel.hasAttribute('data-lucce-price-filter-display')) {
    setPriceFilterMaxLabel(Number(maxLabel.getAttribute('data-lucce-price-filter-display')));
  }
}

let price_min_timer
let price_min_timer_time = 1500

price_min.addEventListener('input',(e)=>{
  clearTimeout(price_min_timer)

  if(e.target.value){
    price_min_timer =setTimeout(()=>{
      let min_val = getPhpValueFromSelectedCurrencyInput(price_min)
      let max_val = getPhpValueFromSelectedCurrencyInput(price_max)

      if(min_val > max_val){
        min_val = max_val
        setPriceFilterInput(price_min, max_val)

        $( "#Slider-Range-Price" ).slider( "option", "values", [max_val, max_val ] )
      }
      else{
        $( "#Slider-Range-Price" ).slider( "option", "values", [min_val, max_val ] )
      }

      let custom_event = new Event('change')
      let filter_container = document.getElementById('Customize-Filter-Container')
      filter_container.dispatchEvent(custom_event)

    },price_min_timer_time)

  }
  
})

let price_max_timer
let price_max_timer_time = 1500

price_max.addEventListener('input',(e)=>{
  clearTimeout(price_max_timer)

  if(e.target.value){
    price_max_timer = setTimeout(()=>{

      let min_val = getPhpValueFromSelectedCurrencyInput(price_min)
      let max_val = getPhpValueFromSelectedCurrencyInput(price_max)
    
      if(max_val < min_val){
        max_val = min_val
        setPriceFilterInput(price_max, min_val)
    
        $( "#Slider-Range-Price" ).slider( "option", "values", [min_val, min_val ] )
      }
      else if (max_val > filter_values_default['PRICE_PHP_MAX']){
        setPriceFilterInput(price_max, filter_values_default['PRICE_PHP_MAX'])
        $( "#Slider-Range-Price" ).slider( "option", "values", [min_val, filter_values_default['PRICE_PHP_MAX']] )
      }
      else{
        $( "#Slider-Range-Price" ).slider( "option", "values", [min_val, max_val ] )
      }

      let custom_event = new Event('change')
      let filter_container = document.getElementById('Customize-Filter-Container')
      filter_container.dispatchEvent(custom_event)

    },price_max_timer_time)
  }
 

})

price_min.addEventListener('input',(e)=>validatePriceInput(e.target))
price_max.addEventListener('input',(e)=>validatePriceInput(e.target))

function validatePriceInput(inputElement) {
  // Get the current input value
  let inputValue = inputElement.value;

  // Keep digits and the selected currency's display precision.
  inputValue = inputValue.replace(/[^0-9.]/g, '');

  // Update the input value with the sanitized value
  var currencyState = window.LucceCurrencyFormatter
    ? window.LucceCurrencyFormatter.getState()
    : null;
  var fractionDigits = currencyState ? 2 : 0;
  inputElement.value = (Number(inputValue) || 0).toLocaleString(undefined, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  });
}

function refreshPriceFilterDisplayFromSlider() {
  if (!document.getElementById('Slider-Range-Price')) return;
  if (!$( "#Slider-Range-Price" ).slider('instance')) return;

  setPriceFilterInput(document.getElementById('Filter-Price-Min'), $( "#Slider-Range-Price" ).slider( "values", 0 ));
  setPriceFilterInput(document.getElementById('Filter-Price-Max'), $( "#Slider-Range-Price" ).slider( "values", 1 ));
  updatePriceFilterCurrencyLabels();
}

document.addEventListener('lucce:currency:updated', refreshPriceFilterDisplayFromSlider);



//load filters
function loadDsiSliders(){
try{
//Carat Slider
$( "#Slider-Range-Carat" ).slider({
  range: true,
  min: filter_values_default['CTS_MIN'],
  max: 1000,
  step:5,
  values: [ filter_values_default['CTS_MIN'], filter_values_default['CTS_MAX'] ],
  slide: function( event, ui ) {
    

    $( "#Filter-Carat-Min" ).val( ui.values[ 0 ]/100);
    $( "#Filter-Carat-Max" ).val( ui.values[ 1 ]/100);

  },
  stop: function(event, ui){
    let value_scale = {
      442:2,
      552.5:3,
      663:4,
      773.5:5,
      884:6,
      994.5:7
    }

    if(diamond_type == '0'){
      let color_values = $( "#Slider-Range-Color" ).slider('option','values')
      if(ui.values[0] <= 150){
        if(color_values[0] < 773.5){
          let max = color_values[1]
          if(max < 773.5){
            max = 773.5
          }
          updateSlider('Color',5,value_scale[color_values[1]])
          $( "#Slider-Range-Color" ).slider( "option", "values", [773.5,color_values[1]])
        }
      } else {
          let max = color_values[1]
          if(max < 663){
            max = 663
          }
          updateSlider('Color',4,max)
          $( "#Slider-Range-Color" ).slider( "option", "values", [663,color_values[1]])

      }
    }

    let custom_event = new Event('change')
    let filter_container = document.getElementById('Customize-Filter-Container')
    filter_container.dispatchEvent(custom_event)
  }
});
$( "#Filter-Carat-Min" ).val($( "#Slider-Range-Carat" ).slider( "values", 0 )/100);
$( "#Filter-Carat-Max" ).val($( "#Slider-Range-Carat" ).slider( "values", 1 )/100);


//Clarity Slider
$( "#Slider-Range-Clarity" ).slider({
    range: true,
    min: 0,
    max: 7,
    values: [ filter_values_default['CLARITY_MIN'], filter_values_default['CLARITY_MAX']],
    slide: function( event, ui ) {

      if(diamond_type == '0'){
        //LAB DIAMOND
        if(ui.values [ 1 ] > 6){
          updateSlider('Clarity',ui.values[ 0 ], 6)
        }
        else if(ui.values [ 0 ] < 3){
          updateSlider('Clarity',3, ui.values[ 1 ])
        }
        else{
          updateSlider('Clarity',ui.values[ 0 ], ui.values[ 1 ])
        }
      } else {
        //NATURAL DIAMOND
        if(ui.values [ 1 ] > 6){
          updateSlider('Clarity',ui.values[ 0 ], 6)
        }
        else if(ui.values [ 0 ] < 2){
          updateSlider('Clarity',2, ui.values[ 1 ])
        }
        else{
          updateSlider('Clarity',ui.values[ 0 ], ui.values[ 1 ])
        }
      }

    },
    stop: function( event, ui ) {
      slider_clarity_stop(ui.values)
      // if(diamond_type == '0'){
      //   //LAB DIAMOND
      //   if(ui.values [ 1 ] > 6){
      //     $( "#Slider-Range-Clarity" ).slider( "option", "values", [ui.values[ 0 ], 6 ] )
      //   }
      //   if(ui.values [ 0 ] < 3){
      //     $( "#Slider-Range-Clarity" ).slider( "option", "values", [3, ui.values[ 1 ] ] )
      //   }
      // } else {
      //   //NATURAL DIAMOND
      //   if(ui.values [ 1 ] > 6){
      //     $( "#Slider-Range-Clarity" ).slider( "option", "values", [ui.values[ 0 ], 6 ] )
      //   }
      //   if(ui.values [ 0 ] < 2){
      //     $( "#Slider-Range-Clarity" ).slider( "option", "values", [2, ui.values[ 1 ] ] )
      //   }
      // }
     

      let custom_event = new Event('change')
      let filter_container = document.getElementById('Customize-Filter-Container')
      filter_container.dispatchEvent(custom_event)
     
    }
  });

  //Color Slider
  $( "#Slider-Range-Color" ).slider({
    range: true,
    min: 0,
    max: 1000,
    values: [ filter_values_default['COLOR_MIN'], filter_values_default['COLOR_MAX'] ],
    step:110.5,
    slide: function( event, ui ) {
        let value_scale = {
          442:2,
          552.5:3,
          663:4,
          773.5:5,
          884:6,
          994.5:7
        }

        if(diamond_type == '0'){
          //LAB DIAMOND
          if(ui.values[ 0 ] < 663 ){
            updateSlider('Color',4,value_scale[ui.values[ 1 ]])
          } 
          else {
            updateSlider('Color',value_scale[ui.values[ 0 ]],value_scale[ui.values[ 1 ]])
          }
        } else {
          //NATURAL DIAMOND
          if(ui.values[ 0 ] < 442 ){
            updateSlider('Color',2,value_scale[ui.values[ 1 ]])
          } 
          else {
            updateSlider('Color',value_scale[ui.values[ 0 ]],value_scale[ui.values[ 1 ]])
          }
        }
        
    },
    stop: function( event, ui ) {
      slider_color_stop(ui.values)

      
      // if(diamond_type == '0'){
      //   //LAB DIAMOND
      //   if(ui.values[ 0 ] < 663 ){
      //     $( "#Slider-Range-Color" ).slider( "option", "values", [ 663, ui.values[ 1 ] ] )
      //   } 
      // } else{
      //   //NATURAL DIAMOND
      //   if(ui.values[ 0 ] < 442 ){
      //     $( "#Slider-Range-Color" ).slider( "option", "values", [ 442, ui.values[ 1 ] ] )
      //   } 
      // }
     
     
      let custom_event = new Event('change')
      let filter_container = document.getElementById('Customize-Filter-Container')
      filter_container.dispatchEvent(custom_event)
    }
  });


  //Cut Slider
$( "#Slider-Range-Cut" ).slider({
  range: true,
  min: 0,
  max: 4,
  values: [ filter_values_default['CUT_MIN'], filter_values_default['CUT_MAX']],
  slide: function( event, ui ) {
      
  },
  stop: function( event, ui ) {

    if(diamond_type == '0'){
      //LAB DIAMOND
      if(ui.values [ 0 ] < 3){
        $( "#Slider-Range-Cut" ).slider( "option", "values", [3, ui.values[ 1 ] ] )
      }
    } else {
      //NATURAL DIAMOND
      if(ui.values [ 0 ] < 3){
        $( "#Slider-Range-Cut" ).slider( "option", "values", [3, ui.values[ 1 ] ] )
      }
    }
    

    let gia_btn =  document.getElementById('Filter-Certificate-Btn-GIA')
    let gia_btn_small = document.getElementById('Filter-Certificate-Btn-GIA-Small-Screen')


    if(diamond_type == '0'){
      //LAB DIAMOND
      if(ui.values[ 0 ] >= 3){
        updateSlider('Cut',ui.values[ 0 ],ui.values[ 1 ])
      } else {
        updateSlider('Cut',3,ui.values[ 1 ])
      }
  
      if(d_shape_not_round == true){
        $( "#Slider-Range-Cut" ).slider( "option", "values", [ 4, 4] )
        updateSlider('Cut',4,4)
      } else if(gia_btn.classList.contains('filter-certificate-btn-active') || gia_btn_small.classList.contains('filter-certificate-btn-active')){
        $( "#Slider-Range-Cut" ).slider( "option", "values", [ 3, 3] )
        updateSlider('Cut',3,3)
      }
    } else{
      //NATURAL DIAMOND
      if(ui.values[ 0 ] >= 3){
        updateSlider('Cut',ui.values[ 0 ],ui.values[ 1 ])
      } else {
        updateSlider('Cut',3,ui.values[ 1 ])
      }
  
      if(d_shape_not_round == true){
        if(ui.values[0] < 3){
          $( "#Slider-Range-Cut" ).slider( "option", "values", [ 3, ui.values[1]] )
          updateSlider('Cut',3,ui.values[1])
        } else {
          $( "#Slider-Range-Cut" ).slider( "option", "values", [ ui.values[0], ui.values[1]] )
          updateSlider('Cut',ui.values[0],ui.values[1])
        }
        
      }
    }
    
    

    let custom_event = new Event('change')
    let filter_container = document.getElementById('Customize-Filter-Container')
    filter_container.dispatchEvent(custom_event)
   
  }
});

 //Price
  $( "#Slider-Range-Fluorescent" ).slider({
    range: true,
    min: 0,
    max: 4,
    values: [ filter_values_default['FLUORESCENT_MIN'], filter_values_default['FLUORESCENT_MAX'] ],
    slide: function( event, ui ) {


      
  
      },
    stop: function(event, ui ){

      if(ui.values [ 0 ] < 2){
        $( "#Slider-Range-Fluorescent" ).slider( "option", "values", [2, ui.values[ 1 ] ] )
      }

      if(ui.values[ 0 ] >= 2){
        updateSlider('Fluorescent',ui.values[ 0 ],ui.values[ 1 ])
      } else {
        updateSlider('Fluorescent',2,ui.values[ 1 ])
      }
      let custom_event = new Event('change')
      let filter_container = document.getElementById('Customize-Filter-Container')
      filter_container.dispatchEvent(custom_event)
    }
    });

  //Price
  $( "#Slider-Range-Price" ).slider({
    range: true,
    min: 0,
    max: filter_values_default['PRICE_PHP_MAX'],
    values: [ filter_values_default['PRICE_PHP_MIN'], filter_values_default['PRICE_PHP_MAX'] ],
    slide: function( event, ui ) {
        setPriceFilterInput(document.getElementById('Filter-Price-Min'), ui.values[ 0 ]);
        setPriceFilterInput(document.getElementById('Filter-Price-Max'), ui.values[ 1 ]);
        updatePriceFilterCurrencyLabels();
      },
    stop: function(){
      let custom_event = new Event('change')
      let filter_container = document.getElementById('Customize-Filter-Container')
      filter_container.dispatchEvent(custom_event)
    }
    });


    setPriceFilterInput(document.getElementById('Filter-Price-Min'), $( "#Slider-Range-Price" ).slider( "values", 0 ));
    setPriceFilterInput(document.getElementById('Filter-Price-Max'), $( "#Slider-Range-Price" ).slider( "values", 1 ));
    updatePriceFilterCurrencyLabels();
    [500, 1500, 3000].forEach(delay => window.setTimeout(refreshPriceFilterDisplayFromSlider, delay));

    return true
  } catch(error){
    console.error('Diamond selector filters could not initialize:', error)
    return false
  }

}

function sliderLoadingInterval(attempt = 0){
  if (loadDsiSliders()) return

  if (attempt < 20) {
    window.setTimeout(() => sliderLoadingInterval(attempt + 1), 250)
  }
}



//NATURAL
//if natural 
if(diamond_type == '1'){
  update_natural_diamond_filter()
  updateSlider('Clarity',2,6)
  updateSlider('Color',2,7)
}


function update_natural_diamond_filter(){
  document.getElementById('Customize-Filter-Intro-Title').innerText = 'Lucce’s Lumiere™ Natural Diamonds'
  //document.getElementById('Customize-Filter-Intro-Para-1').innerText = 'The Lucce Lumiere™ line of Natural Diamonds is a hand-picked selection of the Finest Ethically Sourced and Conflict Free Natural Diamonds. Certified by GIA, these socially responsible natural diamonds represent a love that is pure, virtuous, and refined.'
  document.getElementById('Customize-Filter-Intro-Para-1').innerText = 'The Lucce Lumiere™ line of Natural Diamonds is a hand-picked selection of the Finest Ethically Sourced and Conflict Free Natural Diamonds without any BGM (brownish, greenish, milky) characteristics. Certified by GIA, these high-value natural diamonds represent a love that is pure, exceptional, and refined.'
  document.getElementById('Customize-Filter-Intro-Para-2').style.display = 'none'

  // updateSlider('Clarity',2,6)
  // updateSlider('Color',2,7)
  updateSlider('Cut',3,4)

  document.getElementById('Filter-Info-Color-Text').innerText = 'Diamonds are graded on a scale ranging from D (colorless) to Z (yellow brown), with colorless diamonds (D-F grades) being the most rare and desirable among all. Lucce recommends a color grade of at least I to ensure a visually bright white diamond.'
  document.getElementById('Filter-Info-Clarity-Text').innerText ='Diamonds with a higher clarity grade has fewer or no visible inclusions, resulting in a more brilliant and captivating stone. Lucce selects diamonds with a clarity grade of at least VS2 to ensure your diamonds are eye clean.'
  document.getElementById('Filter-Info-Cut-Text').innerText ='The cut of a diamond is often considered the most crucial factor affecting its beauty. It determines how effectively the stone interacts with light, creating brilliance and sparkle. Lucce only uses diamonds with Very Good (VG) to Excellent (EX) cut to maximize your diamond’s enchanting sparkle.'
}

function update_lab_diamond_filter(){
  document.getElementById('Customize-Filter-Intro-Title').innerText = 'Lucce’s Lavish™ Lab Grown Diamonds'
  document.getElementById('Customize-Filter-Intro-Para-1').innerText = 'The Lucce Lavish™ line of Lab grown Diamonds is a handpicked selection of only the finest IGI- and GIA-Certified Lab Diamonds with the representation of your love in mind.'
  document.getElementById('Customize-Filter-Intro-Para-2').style.display = 'Lucce Lavish™ Lab Diamonds embody a promise that you will only give her the best—only available in G to D color grades with a clarity of VS1 - IF along with an Excellent to Ideal Cut.'

  // updateSlider('Clarity',3,6)
  // updateSlider('Color',4,7)


  document.getElementById('Filter-Info-Color-Text').innerText = 'Diamonds are graded on a scale ranging from D (colorless) to Z (yellow brown), with colorless diamonds (D-F grades) being the most rare and desirable among all. Lucce recommends a color grade of at least G to ensure a visually bright white diamond.'
  document.getElementById('Filter-Info-Clarity-Text').innerText ='Diamonds with a higher clarity grade has fewer or no visible inclusions, resulting in a more brilliant and captivating stone. Lucce selects diamonds with a clarity grade of at least VS1 to ensure your diamonds are eye clean.'
  document.getElementById('Filter-Info-Cut-Text').innerText = 'The cut of a diamond is often considered the most crucial factor affecting its beauty. It determines how effectively the stone interacts with light, creating brilliance and sparkle. Lucce only uses diamonds with Excellent (EX) to Ideal (ID) cut to maximize your diamond’s enchanting sparkle. IGI Ideal is equivalent to GIA Excellent.'
}




function slider_clarity_stop(val){
  if(diamond_type == '0'){
    //LAB DIAMOND
    if(val [ 1 ] > 6){
      $( "#Slider-Range-Clarity" ).slider( "option", "values", [val[ 0 ], 6 ] )
    }
    if(val [ 0 ] < 3){
      if(val [1] >= 3){
        $( "#Slider-Range-Clarity" ).slider( "option", "values", [3, val[ 1 ] ] )
        updateSlider('Clarity',3,val[ 1 ])
      } else {
        $( "#Slider-Range-Clarity" ).slider( "option", "values", [3, 6 ] )
        updateSlider('Clarity',3,6)
      }
    }
  } else {
    //NATURAL DIAMOND
    if(val [ 1 ] > 6){
      $( "#Slider-Range-Clarity" ).slider( "option", "values", [val[ 0 ], 6 ] )
    }
    if(val [ 0 ] < 2){
      $( "#Slider-Range-Clarity" ).slider( "option", "values", [2, val[ 1 ] ] )
      updateSlider('Clarity',2,val[ 1 ])
    }
  }
}

function slider_color_stop(val){
  if(diamond_type == '0'){
    //LAB DIAMOND
    if(val[ 0 ] < 663 ){
      if(val[1] >= 663){
        $( "#Slider-Range-Color" ).slider( "option", "values", [ 663, val[ 1 ] ] )
        updateSlider('Color',4,color_index_numb[val[1]])
      } else {
        $( "#Slider-Range-Color" ).slider( "option", "values", [ 663, 994.5 ] )
        updateSlider('Color',4,7)
      }
      
    } 
  } else{
    //NATURAL DIAMOND
    if(val[ 0 ] < 442 ){
      $( "#Slider-Range-Color" ).slider( "option", "values", [ 442, val[ 1 ] ] )
      updateSlider('Color',2,color_index_numb[val[1]])
    } 
  }
}

sliderLoadingInterval()
